import React from "react";

import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import InstagramIcon from "@material-ui/icons/Instagram";
import FacebookIcon from "@material-ui/icons/Facebook";
import EmailIcon from "@material-ui/icons/Email";

const ConnectionIcon = ({ connectionType }) => {
    if (!connectionType) return null;

    return (
        <React.Fragment>
            {connectionType === 'whatsapp' && <WhatsAppIcon fontSize="small" style={{ marginBottom: '-5px', color: "#25D366" }} />}
            {connectionType === 'instagram' && <InstagramIcon fontSize="small" style={{ marginBottom: '-5px', color: "#e1306c" }} />}
            {connectionType === 'facebook' && <FacebookIcon fontSize="small" style={{ marginBottom: '-5px', color: "#3b5998" }} />}
            {(connectionType === 'email' || !['whatsapp', 'instagram', 'facebook'].includes(connectionType)) && (
                <EmailIcon fontSize="small" style={{ marginBottom: '-5px', color: "#E42527" }} />
            )}
        </React.Fragment>
    );
};

export default ConnectionIcon;
